module.exports = __webpack_public_path__ + "img/1.671c783d.png";